import { Dialog, Transition } from "@headlessui/react";
import classNames from "classnames";
import { useFormik } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import { basePath } from "../config";
import { OrderName, OrderType } from "../../enums";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/auth";
import { useOrderDetails } from "../../contexts/orderDetails";
import AutoCompleteSelect from "../custom/AutoCompleteSelect";

const validate = (values, isPaperOrder) => {
  const errors = {};

  if (values.roll <= 0) {
    errors.roll = "Required";
  }
  if (!isPaperOrder) {
    if (values.label <= 0) {
      errors.label = "Required";
    }
  }
  if (!values.paper_type_name) {
    errors.paper_type_name = "Required";
  }

  return errors;
};

async function doSubmit(
  values,
  action,
  activeUser,
  orderDetails,
  formik,
  setOrderDetails,
  setPapersData,
  setLabelPropToEdit
) {
  console.log({ values });
  try {
    const res = await fetch(basePath + "editOrderDetailsLabelProp", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${activeUser?.remember_token}`,
      },
      body: JSON.stringify({ ...values, id: orderDetails.id }),
    });

    const data = await res.json();

    if (res.status === 401) {
      formik.resetForm({ values: values });
      document.cookie = "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      toast.error(data.message);
      return 0;
    }

    if (data.status) {
      // console.log(order.status)
      setOrderDetails(JSON.parse(data.data));
      setPapersData(JSON.parse(data.papers));
      setLabelPropToEdit(null);
      toast.success(data.message);
      formik.resetForm();
    } else {
      // TODO:: handle form while API fails
      // setOrders(null)
      formik.resetForm({ values: values });
      toast.error("error: " + data.message);
      console.error("error: " + data.message);
    }
  } catch (error) {
    // TODO:: handle form while API fails
    formik.resetForm({ values: values });
    toast.error("error: " + error);
    console.error(
      "edit/OrderDetailsEditLabelProp:: api calling fail =>",
      error
    );
  }
}

export default function OrderDetailsEditLabelProp({
  labelPropToEdit,
  setLabelPropToEdit,
}) {
  const [
    { orderDetails, papersData, paperSizes, labelSizes },
    { setOrderDetails, setPapersData },
  ] = useOrderDetails();

  const [{ activeUser }] = useAuth();
  const isOpen = !!labelPropToEdit;
  const isPaperOrder = orderDetails?.order_type === OrderType.Paper;
  const [selected, setSelected] = useState();

  useEffect(() => {
    if (isOpen) {
      const {
        label_size_id,
        paper_size,
        core,
        ups,
        label,
        roll,
        paper_type,
        daya_mtr,
        mtr_daya,
      } = orderDetails;

      console.log({ orderDetails, label_size_id });

      setSelected(label_size_id);
      formik.setFieldValue("paper_size", paper_size);
      formik.setFieldValue("core", core ?? "");
      formik.setFieldValue("ups", ups ?? "");

      formik.setFieldValue("label", label ?? "");
      formik.setFieldValue("roll", roll ?? "");

      formik.setFieldValue("paper_type_name", paper_type);

      if (isPaperOrder) {
        formik.setFieldValue("daya_mtr", daya_mtr ?? "");
        formik.setFieldValue("mtr_daya", mtr_daya ?? "mtr");
      }
    }
  }, [isOpen, orderDetails]);

  function closeModal() {
    setLabelPropToEdit(null);
  }

  const formik = useFormik({
    initialValues: {
      size: orderDetails.size,
      core: orderDetails.core,
      ups: orderDetails.ups || "",
      paper_type_name: orderDetails.paper_type,
      label: orderDetails.label,
      roll: orderDetails.roll,

      daya_mtr: "",
      mtr_daya: "mtr",
    },
    validate: (values) => validate(values, isPaperOrder),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values, action) => {
      doSubmit(
        values,
        action,
        activeUser,
        orderDetails,
        formik,
        setOrderDetails,
        setPapersData,
        setLabelPropToEdit
      );
    },
  });

  console.log(formik.values);
  useEffect(() => {
    if (!isOpen) {
      setSelected(false);
    }
    formik.setFieldValue("size", selected);
  }, [selected, isOpen]);

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-3xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900"
                >
                  {OrderName[orderDetails.order_type]} Order
                </Dialog.Title>

                <form onSubmit={formik.handleSubmit}>
                  <div className="mt-2 grid grid-cols-2 gap-4">
                    <div className="col-span-2 text-center">
                      <p className="text-orange text-bold">Label Property</p>
                    </div>

                    {!isPaperOrder && (
                      <div>
                        <span className="flex justify-between items-center text-sm font-medium text-slate-700 capitalize">
                          size
                          {/* <button
                         type="button"
                         onClick={() => {
                           setIsAddLabelFormOpen(true);
                         }}
                       >
                         <IoMdAddCircle fill="#ff4c3b" size={20} />
                       </button> */}
                        </span>
                        <div
                          className={classNames(
                            "relative",
                            formik.errors.size && formik.touched.size && "mb-12"
                          )}
                        >
                          <AutoCompleteSelect
                            handleClick={() => {
                              formik.setFieldTouched("size", true);
                            }}
                            selected={selected}
                            setSelected={setSelected}
                            labels={labelSizes}
                            error={
                              formik.errors.size && formik.touched.size ? (
                                <span className="text-sm text-red-600 absolute top-10">
                                  {formik.errors.size}
                                </span>
                              ) : null
                            }
                          />
                        </div>
                      </div>
                    )}

                    <div className={classNames(isPaperOrder && "hidden")}>
                      <label className="block">
                        <span className="block text-sm font-medium text-slate-700 capitalize">
                          quantity of label
                        </span>
                        <input
                          type="number"
                          name="label"
                          // disabled={false}
                          onChange={formik.handleChange}
                          value={formik.values.label}
                          className={classNames(
                            "mt-1 block w-full px-3 py-2 bg-white border  rounded-md text-sm shadow-sm placeholder-slate-400 disabled:bg-slate-300",
                            formik.errors?.label && "border-red-600"
                          )}
                        />
                      </label>
                      {formik.errors.label ? (
                        <span className="text-sm text-red-600">
                          {formik.errors?.label}
                        </span>
                      ) : null}
                    </div>

                    <div>
                      <label className="block">
                        <span className="block text-sm font-medium text-slate-700 capitalize">
                          quantity of roll
                        </span>
                        <input
                          type="number"
                          name="roll"
                          onChange={formik.handleChange}
                          value={formik.values.roll}
                          className={classNames(
                            "mt-1 block w-full px-3 py-2 bg-white border  rounded-md text-sm shadow-sm placeholder-slate-400 disabled:bg-slate-300",
                            formik.errors?.roll && "border-red-600"
                          )}
                        />
                      </label>
                      {formik.errors.roll ? (
                        <span className="text-sm text-red-600">
                          {formik.errors?.roll}
                        </span>
                      ) : null}
                    </div>

                    <div className={classNames(!isPaperOrder && "hidden")}>
                      <span className="block text-sm font-medium text-slate-700 capitalize">
                        Mtr/Daya
                      </span>
                      <div className="flex">
                        <label className="block flex-grow">
                          <input
                            type="text"
                            name="daya_mtr"
                            // disabled={true}
                            onChange={formik.handleChange}
                            value={formik.values.daya_mtr}
                            className={classNames(
                              "mt-1 block w-full px-3 py-2 bg-white border  rounded-s-md text-sm shadow-sm placeholder-slate-400 disabled:bg-slate-300",
                              formik.errors?.roll && "border-red-600"
                            )}
                          />
                        </label>
                        <select
                          name="mtr_daya"
                          onChange={formik.handleChange}
                          value={formik.values.mtr_daya}
                          // disabled={true}
                          className={classNames(
                            "mt-1 block px-3 py-2 bg-white border  rounded-e-md text-sm shadow-sm placeholder-slate-400 disabled:bg-slate-300",
                            formik.errors?.core && "border-red-600"
                          )}
                        >
                          <option value="mtr">mtr</option>
                          <option value="daya">daya</option>
                        </select>
                      </div>

                      {formik.errors.daya_mtr ? (
                        <span className="text-sm text-red-600">
                          {formik.errors?.daya_mtr}
                        </span>
                      ) : null}
                    </div>

                    {isPaperOrder && (
                      <div>
                        <label className="block">
                          <span className="block text-sm font-medium text-slate-700 capitalize">
                            Paper Size
                          </span>

                          <select
                            name="paper_size"
                            onChange={formik.handleChange}
                            value={formik.values.paper_size}
                            disabled={orderDetails.order_status > 2}
                            className={classNames(
                              "mt-1 block w-full px-3 py-2 bg-white border  rounded-md text-sm shadow-sm placeholder-slate-400 disabled:bg-slate-300",
                              formik.errors?.paper_size && "border-red-600"
                            )}
                          >
                            <option value="">select Color Option</option>
                            {paperSizes?.map(({ id, paper_size }) => (
                              <option key={id} value={paper_size}>
                                {paper_size}
                              </option>
                            ))}
                          </select>
                          {/* <input
                            type="text"
                            name="size"
                            onChange={formik.handleChange}
                            value={formik.values.size}
                           
                            className={classNames(
                              "mt-1 block w-full px-3 py-2 bg-white border rounded-md text-sm shadow-sm placeholder-slate-400 disabled:bg-slate-300",
                              formik.errors.size && "border-red-600"
                            )}
                          /> */}
                        </label>
                        {formik.errors.size ? (
                          <span className="text-sm text-red-600">
                            {formik.errors.size}
                          </span>
                        ) : null}
                      </div>
                    )}

                    <div>
                      <label className="block">
                        <span className="block text-sm font-medium text-slate-700 capitalize">
                          select core
                        </span>
                        <input
                          name="core"
                          onChange={formik.handleChange}
                          value={formik.values.core}
                          // disabled={true}
                          className={classNames(
                            "mt-1 block w-full px-3 py-2 bg-white border  rounded-md text-sm shadow-sm placeholder-slate-400 disabled:bg-slate-300",
                            formik.errors?.core && "border-red-600"
                          )}
                        ></input>
                      </label>
                      {formik.errors.core ? (
                        <span className="text-sm text-red-600">
                          {formik.errors?.core}
                        </span>
                      ) : null}
                    </div>

                    <div className={classNames(isPaperOrder && "hidden")}>
                      <label className="block">
                        <span className="block text-sm font-medium text-slate-700 capitalize">
                          select ups
                        </span>
                        <input
                          name="ups"
                          // disabled={true}
                          onChange={formik.handleChange}
                          value={formik.values.ups}
                          className="mt-1 block w-full px-3 py-2 bg-white border  rounded-md text-sm shadow-sm placeholder-slate-400 disabled:bg-slate-300"
                        ></input>
                      </label>
                    </div>

                    <div>
                      <label className="block">
                        <span className="block text-sm font-medium text-slate-700 capitalize">
                          select paper type
                        </span>

                        <select
                          name="paper_type_name"
                          // disabled={false}
                          onChange={formik.handleChange}
                          value={formik.values.paper_type_name}
                          className={classNames(
                            "mt-1 block w-full px-3 py-2 bg-white border  rounded-md text-sm shadow-sm placeholder-slate-400 disabled:bg-slate-300",
                            formik.errors?.paper_type_name && "border-red-600"
                          )}
                        >
                          <option value="">select paper type</option>
                          {papersData?.map(({ id, paper }) => (
                            <option key={id} value={paper}>
                              {paper}
                            </option>
                          ))}
                        </select>
                      </label>
                      {formik.errors.paper_type_name ? (
                        <span className="text-sm text-red-600">
                          {formik.errors?.paper_type_name}
                        </span>
                      ) : null}
                    </div>
                  </div>

                  <div className="mt-4 flex justify-end gap-3">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                      onClick={closeModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      disabled={formik.isSubmitting}
                      className={classNames(
                        "inline-flex justify-center rounded-md border border-transparent bg-green-100 px-4 py-2 text-sm font-medium text-green-900 hover:bg-green-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2",
                        formik.isSubmitting && "disabled:bg-slate-300"
                      )}
                    >
                      Save Changes
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
